import {Component, OnDestroy, OnInit} from "@angular/core";
import {DOCUMENT_TYPES, VALUE_TYPE} from "../../enums/enums";
import {ISector} from "../../services/factory-service-impl/ISector";
import {FactoryService} from "../../services/factory.service";
import {NvSectorEditorComponent} from "../../components/nv-sector-editor/nv-sector-editor.component";
import {canCast, castValue} from "../../utils";
import {WatchService} from "../../services/watch.service";
import {BusService} from "../../services/bus.service";
import {paramsHelper} from "../../helpers/params-helper";
import {UI_TEXTS} from "../../enums/e-texts";
import {Subject} from "rxjs/Subject";
import {IDocument} from "../../interfaces/document.definition";


@Component({
  templateUrl: "./map.location-page.component.html"
})


export class MapsLocationPageComponent implements OnInit, OnDestroy {
  UI_TEXTS = UI_TEXTS;
  pageParams = paramsHelper.page()
    .setDisabledOptionVisible(false)
    .setTitle("Локация - Карты");

  private unsubscribe: Subject<void> = new Subject<void>();

  collectionParams = paramsHelper.collection()
    .setObjectType(DOCUMENT_TYPES.MAP_REFS)
    .setDefaultListLabels()
    .setSearchParams(paramsHelper.search()
      .addNumberParam("id")
      .addStringParam("name"));

  VALUE_TYPE = VALUE_TYPE;
  document: IDocument;
  selected: ISector;
  /*editor: NvSectorEditorComponent = null;*/

  mapParams = <{ w: string, h: string }>{
    w: null,
    h: null
  };

  get self() {
    return this;
  }


  get sectors(): ISector[] {
    return this.document["sectorsConfig"]["sectors"];
  }


  constructor(private busService: BusService,
              private factoryService: FactoryService,
              private watchService: WatchService) {
  }


  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  ngOnInit(): void {
    this.busService.onDocumentUpdated
      .takeUntil(this.unsubscribe)
      .subscribe(
        e => {
          this.document = e.document;
          this.updateMap();
          this.clear();
        });
  }

  getLabel(item: ISector): string {
    return `sid=${item.id} name=${item.name}`;
  }


  onRemoved(removedItem: ISector): void {
   /* if (this.editor) {
      this.editor.removeById(removedItem.id);
    }*/

    this.clearSelected(removedItem);
  }

  clearSelected(removed: ISector) {
    if (removed === this.selected) {
      this.clear();
    }
  }


  onSelected(selectedItem: ISector): void {
    this.clear();
    this.selected = selectedItem;
  }


  add(): void {
  } // add only through editor


  private clear() {
    this.selected = null;
  }


  helloFromEditor(editor: NvSectorEditorComponent) {
    //this.editor = editor;
    this.updateMap();
    this.initCallbacks()
  }


  byeFromEditor() {
    //this.editor = null;
  }


  private updateMap() {
    if (this.document) {
      console.log(this.document);
      this.mapParams.w = this.document["locationConfig"].tileWidth;
      this.mapParams.h = this.document["locationConfig"].tileHeight;
    }

    /*if (this.document && this.editor) {
      this.editor.setMap(this.document);
    }*/
  }

  private initCallbacks() {
    /*if (!this.editor) {
      return;
    }*/

    /*this.editor.setNextSectorIdGetter(() => this.getNextSectorId());

    this.editor.onMapUpdate(
      succeeded => this.onMapUpdate(succeeded));
    this.editor.onAddCallback(
      sectorConfig => this.onAdd(sectorConfig));
    this.editor.onRemove(
      id => this.onRemove(id));
    this.editor.onUpdateSector(
      sectorConfig => this.onUpdateSector(sectorConfig));*/
  }


  private onAdd(sectorConfig: any) {
    let doc: any = sectorConfig;
    this.factoryService.addSectorToMap(this.document, doc);
  }


  private getNextSectorId(): number {
    let nextId: number = -1;
    for (let i = 0; i < this.sectors.length; ++i) {
      if (this.sectors[i].id > nextId) {
        nextId = this.sectors[i].id;
      }
    }
    return nextId + 1;
  }


  trySetMapDimensions() {
    if (canCast(this.mapParams.w, VALUE_TYPE.UINT_GT_ZERO) && canCast(this.mapParams.h, VALUE_TYPE.UINT_GT_ZERO)) {
      let ww = castValue(this.mapParams.w, VALUE_TYPE.UINT_GT_ZERO);
      let hh = castValue(this.mapParams.h, VALUE_TYPE.UINT_GT_ZERO);

      /*this.editor.trySetMapDimensions(ww, hh);*/
    }
  }


  private onMapUpdate(succeeded: boolean) {
    console.log("onMapUpdateonMapUpdateonMapUpdate");


    if (succeeded) {
      this.document["locationConfig"].tileWidth = castValue(this.mapParams.w, VALUE_TYPE.UINT_GT_ZERO);
      this.document["locationConfig"].tileHeight = castValue(this.mapParams.h, VALUE_TYPE.UINT_GT_ZERO);
      this.watchService.notify();
    } else {
      this.mapParams.w = this.document["locationConfig"].tileWidth;
      this.mapParams.h = this.document["locationConfig"].tileHeight;
    }
  }


  private onRemove(id: number) {
    const s = this.getSectorOrThrow(id);
    this.clearSelected(s);
    this.sectors.splice(this.sectors.indexOf(s), 1);
    this.watchService.notify();
  }


  private findSectorById(id: number): ISector {
    for (let i = 0; i < this.sectors.length; ++i) {
      if (this.sectors[i].id === id) {
        return this.sectors[i];
      }
    }
    return null;
  }

  private onUpdateSector(sectorConfig: any) {
    const s = <any>this.getSectorOrThrow(sectorConfig.id);
    s.x = sectorConfig.x;
    s.y = sectorConfig.y;
    s.w = sectorConfig.w;
    s.h = sectorConfig.h;
    this.watchService.notify();
  }


  private getSectorOrThrow(id: number): ISector {
    const s = this.findSectorById(id);
    if (s === null) {
      throw new Error(`Cannot find such sector! id: ${id}, ${JSON.stringify(this.document)}`);
    }
    return s;
  }


}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/pages/location/map.location-page.component.ts